<template>
  <div>
    <div
      v-if="value && value.profile"
      key="logo"
      :style="{ width: size, height: size }"
      class="white rounded-circle header-img-bg"
    >
      <div
        :style="{ backgroundImage: `url(${value.profile})` }"
        class="bg-filter"
      />
      <img  :src="value.profile" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "profilePhotos",
  props: {
    value: Object,
    size: {
      type: String,
      default: "100px",
    },
  },
};
</script>

<style scoped>
.header-img-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  position: relative;
  overflow: hidden;
  margin: auto;
}

.header-img-bg >>> .bg-filter {
  position: absolute;
  inset: -4px;
  background-size: cover;
  filter: blur(1.8px) brightness(1.3) opacity(0.8);
}

.header-img-bg >>> img {
  position: relative;
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
}
</style>
